import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  flightPhases: [],
}

const getters = {
  flightPhaseData() {
    return axios.get('/FlightPhase')
  },
}

const saves = {}

export default class FlightPhaseService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
